<template>
<div>
    <!-- 展覽主視覺輪播 -->
    <div class="slides_topBanner mt-4">
      <carousel :perPage="1" :autoplay="true" :autoplayTimeout="3000" :loop="true" :paginationActiveColor="'#0689e6'" :paginationSize="13">

        <slide v-for="(banner, index) in banner_info" :key="index">
          <div class="banner_item">
            <a :href="banner.href" target="_blank">
              <img :src="banner.src" :alt="banner.alt" class="img-fluid" />
            </a>
          </div>
        </slide>
      </carousel>
    </div>
    <!-- 展覽主視覺輪播 -->

    <div class="container-fluid mb-5 position-relative">
      <!-- 關於我們 -->
      <div id="about_us" class="div_bottom_shadow">
        <div class="container py-4">
          <div class="index_topic_blcok">
            <div class="topic_border">
              <p class="topic_eng">ABOUT US</p>
            </div>
          </div>
          <div class="about_logo_block row justify-content-center">
            <div class="col-6 col-sm-4 col-md-2 p-4" style=" text-align:center;" v-for="(about, index) in about_info" :key="index">
              <img :src="about.src" :alt="about.alt" class="img-fluid" />
              <p class="py-2">{{about.content}}</p>
            </div>
          </div>
        </div>
      </div>
      <!-- 關於我們 -->

      <!-- 照片輪播 -->
      <div class="container-fluid slides_photo my-4 py-4 ">
        <carousel :perPageCustom="[[768, 2], [1024, 3]]" :autoplay="true" :autoplayTimeout="3000" :loop="true" :paginationEnabled="false">
          <slide v-for="(picSlider, index) in about_slider" :key="index">
            <div class="photo_item">
              <img :src="picSlider.src" :alt="picSlider.alt" class="img-fluid" />
            </div>
          </slide>
        </carousel>
      </div>
      <!-- 照片輪播 -->

      <!-- 展覽資訊 -->
      <div id="exhibition" class="container index_exhibit_block divider-outside-aside py-5">
        <div class="index_topic_blcok">
          <div class="topic_border">
            <p class="topic_eng">EXHIBITION<br>CALENDAR</p>
          </div>
          <div>
            <h4 style="color:#8c8c8d;padding-left:28px;"><i class="fas fa-calendar"></i> 2 0 2 3</h4>
          </div>
        </div>

        <div class="row exhibit_list p-0 py-4 p-sm-4 p-md-2 p-lg-3 p-xl-4">
          <div class="list_item col-12 col-md-4 p-3 pt-3 pt-md-5" v-for="item in calendars" :key="item.id">
            <a :href="item.link" target="_blank">
              <div class="card item_img_border">
                <div class="">
                  <img class="card-img-top" :src="item.image_url" :alt="item.content">
                </div>
                <div class="card-body">
                  <h5 class="exhibit_title">{{ item.content }}</h5>
                </div>
              </div>
            </a>
          </div>
        </div>

        <!-- 手機版摺疊panel -->
        <div style="display:none;">
          <div id="accordion">
            <div>
              <div id="headingPanel" class="text-center">
                  <button class="btn btn-primary collapsed" data-toggle="collapse" data-target="#collapsePanel" aria-expanded="false" aria-controls="collapsePanel">
                    more
                  </button>
              </div>
              <div id="collapsePanel" class="collapse" aria-labelledby="headingPanel" data-parent="#accordion">
                <div class=" container collapse-body">
                最後六則exhibit block
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 手機版摺疊panel -->
      </div>
      <!-- 展覽資訊 -->

      <!-- 展館資訊 -->
      <div id="transportation" class="container py-5">
        <div class="index_topic_blcok">
          <div class="topic_border">
            <p class="topic_eng">TRANSPORTATION</p>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-7 col-md-12 justify-content-center d-flex" style="flex-flow:column;" v-for="(item, index) in transportation" :key="index">
            <h3 style="padding:20px;font-family:'Roboto Slab';">{{item.location}}</h3>
            <div style="padding:20px;">{{item.content}}</div>
            <div style="padding:20px;" v-html="item.info"></div>
          </div>
          <div class="col-lg-5 col-md-12 dp-flex aic">
            <img src="../assets/index/intro_map.jpg" alt="map" style="max-width:100%;display:block;margin:auto;">
          </div>
        </div>
      </div>
      <!-- 展館資訊 -->

      <!-- 飯店推薦 -->
      <div id="hotelaccom" class="container py-5">
        <div class="index_topic_blcok">
          <div class="topic_border">
            <p class="topic_eng">ACCOMMODATION</p>
          </div>
        </div>
        <div class="max-w-xl" style="margin:40px 0;">
          <p class="fz20" style="line-height:2;">
            You can search hotel <a href="https://eng.taiwan.net.tw/m1.aspx?sNo=0000212&t=r" target="_blank">here</a>, and find a suitable one near TWTC<br>
            The region of Songshan, Xinyi, and Da’an District are near TWTC (No.5, Xinyi Rd., Sec.5, Xinyi District ,Taipei City)<br>
            Special Price can be offered to exhibitors of Top-Link.
          </p>
        </div>
        <div class="row" style="overflow:auto;">
          <table class="hotel_table">
            <tr class="fz20 text-white ta-c">
              <th class="w-33">Hotel</th>
              <th class="w-50">Address</th>
              <th>Star Rating</th>
            </tr>
            <tr v-for="hotel in hotels" :key="hotel.name">
              <td class="w-25 fz20 ta-c">{{ hotel.name }}</td>
              <td class="w-50 fz15" v-html="hotel.address" style="padding:20px;"></td>
              <td class="w-25 fz15" style="padding:20px;">{{ hotel.star }}</td>
            </tr>
          </table>
        </div>
      </div>
      <!-- 飯店推薦 -->

      <!-- 合作單位 -->
      <div class="container" style="display:none;">
        <div class="index_topic_blcok">
          <div class="topic_border">
            <p class="topic_eng">PARTNERS</p>
          </div>
        </div>
        <div class="py-4">
          <carousel :perPageCustom="[[768, 2], [1024, 4]]" :autoplay="true" :autoplayTimeout="3000" :loop="true" :paginationEnabled="false" :navigationEnabled="true">
            <slide v-for="(partners, index) in partner" :key="index">
              <div class="logo_item">
                <img :src="partners.src" :alt="partners.alt" class="img-fluid" />
              </div>
            </slide>
          </carousel>
        </div>
      </div>
      <!-- 合作單位 -->
    </div>

</div>
</template>

<script>
export default {
  data () {
    return {
      banner_info: require('../plugins/banner.js'),
      about_info: require('../plugins/about.js'),
      about_slider: require('../plugins/about_slider.js'),
      calendars: require('../plugins/calendars.js'),
      transportation: require('../plugins/transportation.js'),
      hotels: require('../plugins/hotels.js'),
      partner: require('../plugins/partner.js'),
    }
  },
  mounted() {
    $(function(){
      // 切換nav_menu
      var nav_menu = $('.nav-menu');
      var footer = $('footer');
      nav_menu.eq(0).hide();
      nav_menu.eq(1).show();
      footer.eq(0).hide();
      footer.eq(1).show();
      // 隱藏搜尋框
      $('#topSearchBox').hide();
      // 隱藏中文頁面切換選項
      $('#lang_chi').text('CH');

      // 平滑滾動
      var nav_eng_items = $('.nav_eng').children('a');
      // console.log(nav_eng_items);
      clickScroll(nav_eng_items, 'href', 500);

      function clickScroll(arr, attr, speed){
        arr.on('click', function(){
          let target = $($(this).attr(attr)).offset().top;
          target -= 65;
          $('html, body').stop().animate({scrollTop: target}, speed);
          return false;
        })
      };

      // Side Menu Click
      var top_menu_btn = $('.top_menu_btn');
      var index_filter = $('#index_filter');
      var side_menu = $('.side_menu');
      top_menu_btn.on('click', function(){
        index_filter.stop().fadeIn(300);
        side_menu.stop().animate({left: '-20px'}, 200);
      });
      $('#index_filter, .side_menu_list>ul>a').on('click', function(){
        side_menu.stop().animate({left: '-320px'}, 200);
        index_filter.stop().fadeOut(500);
      })
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/**index_topic**/
.index_topic_blcok .topic_border {
  padding: 0px 0 1px 1.6rem;
  border-left:1px solid #d6d6d6;
  font-size:2rem; line-height:1;
}
.index_topic_blcok .topic_border .topic_eng {
  color:#8c8c8d;
  line-height:1.1;
}
.index_topic_blcok .topic_border .topic_cht {
  color:#b0b0b0;
  letter-spacing: 9px;
}

/**index shadow**/
.div_bottom_shadow {
  position:relative;
  background-color: #fff;
}
.div_bottom_shadow:before {
  content: "";
  position:absolute;
  z-index: -1;
  width:90%;
  bottom: 0;
  height: 10px;
  left: 5%;
  border-radius: 100px / 5px; -moz-border-radius: 100px / 5px; -webkit-border-radius: 100px / 5px;
  box-shadow:0 0 30px rgba(0,0,0,0.2); -moz-box-shadow:0 0 30px rgba(0,0,0,0.2); -webkit-box-shadow:0 0 30px rgba(0,0,0,0.2);
}

/* 關於我們 */
#about_us img {
  transition:all 0.2s;
}
#about_us img:hover {
  transform:scale(1.1);
}

/**照片輪播**/
.photo_item{
  padding: 1%;
}

/**展覽資訊**/
.index_exhibit_block{
  background-color:#fff;
}
.divider-outside-aside {
  position:relative;
}
.divider-outside-aside:before {
  content: "";
  position: absolute;
  z-index: -1;
  width: 98.5%;
  height: 90%;
  top: 4%;
  margin: 0 auto;
  border-radius: 10%; -moz-border-radius: 10%; -webkit-border-radius: 10%;
  box-shadow: -5px 0 40px rgba(0,0,0,0.4); -moz-box-shadow: -5px 0 40px rgba(0,0,0,0.4); -webkit-box-shadow: 0 0 40px rgba(0,0,0,0.4);
}
@media (max-width: 992px){
  .divider-outside-aside:before {
    border-radius: 5%; -moz-border-radius: 5%; -webkit-border-radius: 5%;
    width: 97.8%;
  }
}
@media (max-width: 768px){
  .divider-outside-aside:before {
    border-radius: 0%; -moz-border-radius: 0%; -webkit-border-radius: 0%;
    box-shadow: -6px 0 30px rgba(0,0,0,0.4); -moz-box-shadow: -6px 0 30px rgba(0,0,0,0.4); -webkit-box-shadow: -6px 0 30px rgba(0,0,0,0.4);
    width: 95.5%;
  }
}

.list_item a {
  color:#3f3f3f;
}
.list_item a:hover {
  text-decoration: none;
}
.list_item a:hover .exhibit_title {
  color:#007bff;
}
.item_img_border {
  border:1px solid rgba(0, 0, 0, 0.2);
  border-radius: 2px; -moz-border-radius: 2px; -webkit-border-radius: 2px;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.3); -moz-box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.3); -webkit-box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.3);
}
.exhibit_title {
  height: 1.5rem;
  font-size: 1rem;
  font-weight:500;
  text-align: center;
}
@media (max-width: 1200px){
  .exhibit_title {
    height: 3rem;
  }
}
@media (max-width: 768px){
  .exhibit_title {
    height: 2rem;
    font-size: 1.2rem;
  }
}
@media (max-width: 480px){
  .exhibit_title {
    height: 3rem;
    font-size: 1.2rem;
  }
}

/**產業資訊**/
.tabs_container {
  width: 100%;
  border-bottom: 1px solid #aaa;
  box-sizing: border-box;
}

.tabs_container .tabs_item {
  width: 24%;
}
.tabs_container .tabs_item > input {
	display: none;
}
.tabs_container .tabs_item > label {
	display: inline-block;
	color: #8e8e8e;
	font-size: 0.8rem;
	text-align: left;
	font-weight: bolder;
	box-sizing: border-box;
  padding: 3%;
  white-space:nowrap;
}
.tabs_container .tabs_item > label:last-of-type {
  border-right: none;
}
.tabs_container .tabs_item > label:hover {
	cursor: pointer;
}

.tabs_container .tabs_item > input:checked + label {
  color: #000;
	font-weight: bolder;
  border: 1px solid #8e8e8e;
  border-bottom: none;
  height: 100%;
  box-sizing: border-box;
  padding: 3%;
  white-space:nowrap;
}
@media (max-width: 1200px){
  .tabs_container .tabs_item > label,
  .tabs_container .tabs_item > input:checked + label {
    white-space:normal;
  }
}
.tab_content {
		width: 100%;
		margin: 0 0 20px 0;
		display: none;
		padding: 0;
		background-color: #ffffff;
	}
	#tab0:checked ~ #content0,
	#tab1:checked ~ #content1,
	#tab2:checked ~ #content2,
	#tab3:checked ~ #content3 { display: block; }




/**合作單位**/
.logo_item {
  text-align: center;
  border:1px solid rgba(0, 0, 0, 0.2);
  margin: 3%;
}
.logo_item img {
  height:100px;
}

/** 飯店資訊 **/
.hotel_table,
.hotel_table th,
.hotel_table td {
  border:1px solid white;
  box-sizing:border-box;
  border-collapse:collapse;
}
.hotel_table {
  width: 1200px;
}
.hotel_table tr:nth-child(odd){
  background:#e6e6e6;
}
.hotel_table tr:first-child {
  background-color: #e8951d;
  height: 50px;
  padding: 15px;
}
.hotel_table tr:not(:first-child):hover {
  background: #d4e9ff;
  cursor:default;
}
@media (max-width: 768px){
  .hotel_table {
    width: auto;
    min-width:530px;
  }
  .hotel_table th {
    font-size:14px;
    padding:10px;
  }
	.hotel_table td {
	font-size:12px;
  padding:15px;
	}
}


/**welcome panel**/
@media (max-width: 768px){
  .welcome_panel {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home_eng.vue